<template>
    <div class="aboutUs-page">
        <div class="public-banner bg-cover">
            <div class="absolute center text-center color-white">
                <h1>关于探物</h1>
                <p class="English">About Us</p>
            </div>
        </div>
        <div class="page-content">
            <div class="container">
                <p class="info">探物（TanWorth）于2016年3月在深圳成立，辐射全国<br />致力于「信用租赁」模式的推进，为消费者带来更具品质的租赁服务，更与阿里巴巴旗下蚂蚁金服、顺丰速运等金融、服务类行业巨头达成战略性合作，大大简化了服务流程，为用户提供流畅、友好的消费流程和体验，让消费者免去高昂押金、运输破损等顾虑</p>
                <div class="image-wrap display-flex-between">
                    <div class="left-part item bg-cover"></div>
                    <div class="right-part display-flex-between flex-column">
                        <div class="top-part item bg-cover"></div>
                        <div class="bottom-part item bg-cover"></div>
                    </div>
                </div>
                <p class="info">探物平台上提供的产品囊括了相机、镜头、无人机、游戏、VR、影音、显卡等丰富的数码品类，特别是相机、无人机等强需求却低频使用的数码产品最受欢迎，以租代买，拒绝闲置浪费，更符合「新租赁经济」的理念<br />选品上，探物与众多一线品牌合作，为消费者提供最新、最丰富、最好用的数码产品，还与供应商有着密切的合作，拥有完整的上下游供应链，从采购、租赁、归还、维护，甚至到产品最后的残值处理，都形成完整的生态闭环</p>
            </div>
            <div class="history-wrap">
                <div class="container">
                    <div class="history-title display-flex-between">
                        <span>发展历程</span>
                        <div>
                            <img class="slide-btn btn-left my-swiper-prev" src="~@assets/img/slide-right.png" slot="button-prev">
                            <img class="slide-btn my-swiper-next" src="~@assets/img/slide-right.png" slot="button-next">
                        </div>
                    </div>
                    <swiper :options="swiperOptionHistory" class="history-swiper">
                        <swiper-slide class="display-flex-between slide-item slide1">
                            <div class="history-item">
                                <span class="year">Future</span>
                                <p class="time">未来</p>
                            </div>
                            <div class="history-item">
                                <span class="year">2019</span>
                                <p class="time">11月/Nov</p>
                                <p class="content">在2019年6月，探物荣登「创业36计×胡润百富2019中国最具投资价值新星企业」 榜单，也是深圳Top50榜单中，唯一一家「数码租赁」企业。</p>
                            </div>
                            <div class="history-item">
                                <p class="time">3月/Mar</p>
                                <p class="content">2019年上半年，更接入了蚂蚁区块链，让广大符合信用等级的用户不再受限于高昂押金，租到自己心仪的数码产品，将信用运用场景推向全新的高度。</p>
                                <p class="time">7月/Jul</p>
                                <p class="content">在未来，希望能与每一个热爱科技产品，喜欢极客文化，关注数码资讯的小伙伴一起成长，一起探索更多的可能。</p>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="display-flex-between slide-item slide2">
                            <div class="history-item">
                                <span class="year">2018</span>
                                <p class="time">3月/Mar</p>
                                <p class="content">2018年，探物获得蚂蚁金服千万元级的战略投资，还为支付宝的芝麻信用创造了更丰富的使用场景。</p>
                            </div>
                            <div class="history-item">
                                <span class="year">2017</span>
                                <p class="time">9月/Sep</p>
                                <p class="content">2017年9月探物成功入驻支付宝平台，引领新奇科技数码租赁。</p>
                            </div>
                            <div class="history-item">
                                <span class="year">2016</span>
                                <p class="time">3月/Mar</p>
                                <p class="content">2016年3月公司成立，总部设立在深圳，辐射全国。</p>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
            <div class="container">
                <div class="video-wrap">
                    <video :src="videoSrc" controls muted autoplay></video>
                    <p class="videoBar">
                        <span :style="{ 'width': videoBarWidth + '%' }"></span>
                    </p>
                    <!-- <span v-if="!isPlay" class="poster bg-cover flex-center" @click="play">
                        <img src="~@assets/img/play-white.png">
                    </span> -->
                </div>
                <p class="info">在「新租赁经济」被越来越多国人接受的大背景下，探物切中了数码租赁的使用场景，再加上企业良性的运转下，挤上了数码租赁行业的排头兵。然而这一行业在国内尚处于起步阶段，有租赁市场成熟的欧美国家作参考，再加上中国市场独特而强劲的创新力，「新租赁经济」市场潜力想必更巨大。</p>

                <div class="map-wrap">
                    <div id="baidu-map">
                        <img src="https://prod-static.tanwuapp.com/official-website/sz-store-location.png" alt="" style="width: 100%;height: 100%;">
                    </div>
                    <div class="map-tip">
                        <p class="title">联系我们</p>
                        <p class="item flex flex-algin-center">
                            <img class="icon" src="~@assets/img/address-black.png">
                            <span>广东省深圳市南山区粤海街道科技园社区科苑路15号科兴科学园 A2栋1701</span>
                        </p>
                        <p class="flex flex-algin-center">
                            <img class="icon" src="~@assets/img/partner-phone.png">
                            <span>4000089505（周一至周日 9:00-20:00）</span>
                        </p>
                    </div>
                </div>

                <!-- <div class="address-wrap display-flex-between">
                    <div class="item">
                        <img class="image block width-full" src="~@assets/img/aboutUs/aboutUs-04.jpg">
                        <p class="name">
                            深圳总部
                            <span>SHENZHEN</span>
                        </p>
                        <ul class="info-list">
                            <li>
                                <span>地址</span>
                                深圳市南山区科技园飞亚达科技大厦1103室
                                <img class="icon" src="~@assets/img/address-green.png">
                            </li>
                            <li>
                                <span>电话</span>
                                4000089505
                            </li>
                            <li>
                                <span>邮箱</span>
                                bd@tanwuapp.com
                            </li>
                            <li>
                                <span>时间</span>
                                周一至周日 9:30-18:30
                            </li>
                        </ul>
                    </div>
                    <div class="item">
                        <img class="image block width-full" src="~@assets/img/aboutUs/aboutUs-05.jpg">
                        <p class="name">
                            北京网点
                            <span>BEIJING</span>
                        </p>
                        <ul class="info-list">
                            <li>
                                <span>地址</span>
                                北京市朝阳区广渠路36号院5号楼B座1405
                                <img class="icon" src="~@assets/img/address-green.png">
                            </li>
                            <li>
                                <span>电话</span>
                                18519204755
                            </li>
                            <li>
                                <span>邮箱</span>
                                bd@tanwuapp.com
                            </li>
                            <li>
                                <span>时间</span>
                                周一至周日 9:30-18:30
                            </li>
                        </ul>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { CONFIG, network } from '@assets/js/apis';
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
    data() {
        return {
            videoSrc: 'https://resource.tanwuapp.com/1527928854792.mp4',
            isPlay: false,
            videoBarWidth: 0,
            swiperOptionHistory: {
                navigation: {
                    nextEl: '.my-swiper-next',
                    prevEl: '.my-swiper-prev'
                }
            }
        }
    },
    components: {
        swiper,
        swiperSlide
    },
    created() {
    },
    mounted() {
        //    window.addEventListener('scroll', this.pageScroll);
        this.initVideoBar();
    },
    destroyed() {
        // window.removeEventListener('scroll', this.pageScroll)
    },
    methods: {
        play() {
            document.querySelector('video').play();
            this.isPlay = true;
        },
        initVideoBar() {
            const $video = document.querySelector('video');
            if ($video) {
                $video.addEventListener('timeupdate', () => {
                    this.videoBarWidth = $video.currentTime / $video.duration * 100;
                })
            }
        },
        pageScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            console.log(scrollTop)
            if (scrollTop > 200) {
                document.querySelector('.anim1').classList.add('active');
            } else {
                document.querySelector('.anim1').classList.remove('active');
            }
        }
    }
}
</script>

<style lang="scss">
.aboutUs-page {
    .public-banner {
        background-image: url('https://resource.tanwuapp.com/FhzzO328MDlcljZ8XhW05Lv2nSGZ');
    }

    .page-content {
        padding-top: 60px;
        padding-bottom: 100px;
    }

    .info {
        font-size: 20px;
        line-height: 40px;
    }

    .image-wrap {
        margin: 40px auto;

        .item {
            background-color: #eeeeee;
        }

        >.left-part {
            width: 39.3333%;
            padding-bottom: 68.33%;
            background-image: url('https://resource.tanwuapp.com/FpvfgTyWgbY6bRQeIn1DKrhUwwDg');
        }

        >.right-part {
            width: 59%;

            >.top-part {
                padding-bottom: 56.4971%;
                background-image: url('https://resource.tanwuapp.com/FkDIPYxwPl2KxOTDpiE2XiXKEAwd');
            }

            >.bottom-part {
                padding-bottom: 56.4971%;
                background-image: url('https://resource.tanwuapp.com/Fv_0UV6nWBo9CP0NVHrg8sIdLVXz');
            }
        }
    }

    .address-wrap {
        margin-top: 80px;

        .item {
            width: 48.3333%;

            .name {
                font-size: 26px;
                font-weight: bold;

                >span {
                    color: #bbbbbb;
                    font-size: 22px;
                    padding-left: 15px;
                    font-weight: normal;
                }
            }

            .image {
                margin-bottom: 30px;
            }

            .info-list {
                margin-top: 14px;
                line-height: 2;

                li {
                    display: flex;
                    align-items: center;

                    >span {
                        font-weight: bold;
                        padding-right: 16px;
                    }

                    .icon {
                        margin-left: 10px;
                        width: 14px;
                        height: 18px;
                    }
                }

            }
        }
    }

    .video-wrap {
        position: relative;
        margin-bottom: 40px;
        margin-top: 80px;

        video {
            display: block;
            width: 100%;
        }

        .poster {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            cursor: pointer;
            background-image: url(https://resource.tanwuapp.com/Fo0RzXUbXA6Hbk364VtcBqPziUkn);

            img {
                width: 80px;
                opacity: 0.8;
                transition: opacity 0.2s;
            }

            &:hover img {
                opacity: 1;
            }
        }

        .videoBar {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 3px;
            background: rgba($color: #ffffff, $alpha: 0.3);

            >span {
                display: block;
                height: 3px;
                background: #3ED8C4;
                transition: width 0.6s;
            }
        }
    }

    .anim1 {
        transition: all 0.4s ease-in;
        transform: translateX(-5%);
        opacity: 0;

        &.active {
            transform: translateX(0);
            opacity: 1;
        }
    }

    .map-wrap {
        position: relative;
        height: 600px;
        margin-top: 80px;

        #baidu-map {
            height: 100%;
        }

        .map-tip {
            color: #000000;
            font-size: 14px;
            background: #ffffff;
            position: absolute;
            width: 460px;
            height: 116px;
            bottom: 30px;
            left: 30px;
            box-sizing: border-box;
            padding-top: 11px;
            padding-left: 28px;
            border-radius: 6px;

            .title {
                font-size: 18px;
                font-weight: bold;
                line-height: 25px;
                margin-bottom: 8px;
            }

            .icon {
                width: 24px;
                height: 24px;
                margin-right: 6px;
            }

            .item {
                margin-bottom: 6px;
            }
        }
    }

    .history-wrap {
        padding-top: 81px;
        overflow: hidden;

        .history-title {
            font-weight: bold;
            font-size: 28px;
            margin-bottom: 40px;
            line-height: 40px;

            .slide-btn {
                margin-left: 6px;
                display: inline-block;
                outline: none;
                width: 32px;
                height: 32px;
                cursor: pointer;
                user-select: none;

                &.btn-left {
                    transform: rotate(180deg);
                }
            }
        }

        .history-swiper {
            padding-top: 26px;
            overflow: visible !important;

            .slide-item {
                border-top: 1px solid #eeeeee;
            }

            .history-item {
                position: relative;
                padding-top: 28px;
                text-align: justify;

                .year {
                    position: absolute;
                    top: -25px;
                    left: -17px;
                    padding-left: 17px;
                    padding-right: 17px;
                    color: #3ED8C4;
                    font-size: 30px;
                    line-height: 50px;
                    background: #ffffff;
                }

                .time {
                    font-weight: bold;
                    color: #333333;
                    font-size: 26px;
                    line-height: 50px;
                }

                .content {
                    font-size: 18px;
                    line-height: 1.66666;
                    margin-bottom: 10px;
                }
            }

            .slide1 {
                .history-item {
                    width: 33.33%;

                    &:first-child {
                        width: auto;
                    }

                    &:last-child {
                        margin-right: 7%;
                    }
                }
            }

            .slide2 {
                .history-item {
                    width: 28%;
                }
            }
        }
    }


}
</style>



// WEBPACK FOOTER //
// src/pages/content/children/aboutUs.vue